import { Navigate, Route, Routes } from 'react-router-dom';
import { Keyed } from '../../shared/components/Common';
import TransferSearch from './TransferSearch';
import TransferList from './TransferList';
import TransferDetails from './TransferDetails';
import TransferReview from './TransferReview';
import TransferConfirmation from './TransferConfirmation';
import TransferBookings from './TransferBookings';
import TransferBookingDetails from './TransferBookingDetails';

// Mounted at /transfers/*
export default function TransferRoutes() {
  return (
    <Routes>
      <Route index element={<TransferSearch />} />
      <Route path="results" element={<Keyed page={TransferList} />} />
      <Route path="cab" element={<Keyed page={TransferDetails} />} />
      <Route path="review" element={<TransferReview />} />
      <Route path="confirmation/:bookingId" element={<TransferConfirmation />} />
      <Route path="bookings" element={<TransferBookings />} />
      <Route path="bookings/:bookingId" element={<TransferBookingDetails />} />
      <Route path="*" element={<Navigate to="/transfers" replace />} />
    </Routes>
  );
}
